var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdf({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.657,
    height: 31.608,
    viewBox: "0 0 27.657 31.608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pdf",
    transform: "translate(-32)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_378",
    "data-name": "Trazado 378",
    d: "M98.009,0A2,2,0,0,0,96,1.976V29.633a2,2,0,0,0,2.009,1.976H118.1a2,2,0,0,0,2.009-1.976V7.9L112.076,0Z",
    transform: "translate(-60.457)",
    fill: "#e2e5e7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_379",
    "data-name": "Trazado 379",
    d: "M353.772,7.087h5.315L352,0V5.315A1.777,1.777,0,0,0,353.772,7.087Z",
    transform: "translate(-299.429)",
    fill: "#b0b7bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_380",
    "data-name": "Trazado 380",
    d: "M389.315,133.315,384,128h5.315Z",
    transform: "translate(-329.658 -119.91)",
    fill: "#cad1d8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_381",
    "data-name": "Trazado 381",
    d: "M56.114,249.744a.954.954,0,0,1-1,.886H33a.954.954,0,0,1-1-.886v-8.858A.954.954,0,0,1,33,240h22.1a.954.954,0,0,1,1,.886Z",
    transform: "translate(0 -224.266)",
    fill: "#f15642"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1918",
    "data-name": "Grupo 1918",
    transform: "translate(36.858 18.568)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_382",
    "data-name": "Trazado 382",
    d: "M101.744,294.809a.487.487,0,0,1,.481-.489h1.636a1.771,1.771,0,0,1,0,3.542h-1.183v.935a.445.445,0,0,1-.454.488.477.477,0,0,1-.481-.488Zm.935.4v1.765h1.183a.883.883,0,0,0,0-1.765Z",
    transform: "translate(-101.744 -294.32)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_383",
    "data-name": "Trazado 383",
    d: "M188.313,300.373a.443.443,0,0,1-.489-.438v-4.023a.482.482,0,0,1,.489-.439h1.622c3.237,0,3.166,4.9.064,4.9Zm.446-4.037v3.173h1.176c1.912,0,2-3.173,0-3.173h-1.176Z",
    transform: "translate(-183.058 -295.408)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_384",
    "data-name": "Trazado 384",
    d: "M288.063,296.378V297.5h1.806a.548.548,0,0,1,.51.5.492.492,0,0,1-.51.425h-1.806v1.487a.42.42,0,0,1-.424.438.45.45,0,0,1-.5-.438V295.9a.448.448,0,0,1,.5-.439h2.486a.442.442,0,0,1,.5.439.489.489,0,0,1-.5.482h-2.062Z",
    transform: "translate(-276.872 -295.393)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_385",
    "data-name": "Trazado 385",
    d: "M115.542,416.886H96v.886h19.542a.968.968,0,0,0,1.029-.886V416A.968.968,0,0,1,115.542,416.886Z",
    transform: "translate(-60.457 -389.707)",
    fill: "#cad1d8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.bcc3f57f37c4d429ac46ab299f67b91e.svg";
export { ForwardRef as ReactComponent };